import React from 'react'
import { connect } from 'react-redux'
import { RootState } from '../../redux/store'
import styles from './adminPage.module.scss'
import AuthorForm from '../authorForm/authorForm'
import PublisherForm from '../publisherForm/publisherForm'
import BookForm from '../bookForm/bookForm'

interface SaveDataProps {}

const AdminPage = ({}: SaveDataProps) => {
  return (
    <div className={styles.root}>
      <BookForm />
      <AuthorForm />
      <PublisherForm />
    </div>
  )
}

const mapStateToProps = (stat: RootState) => ({})

export default connect(mapStateToProps, {})(AdminPage)
